module.exports = __webpack_public_path__ + "static/3-70bffe4120058c03be3dc093e65a4d78.png";